<ng-container *ngIf="result">
  <div class="row no-gutters my-4 mb-cms-line-search-result-wrapper"
       [ngClass]="[result.hasText ? '' : 'no-text']"
       data-cy="mb-search-cms-line-wrapper"
  >
    <mb-cms-search-result-item *ngIf="!result.faqSnippet?.length && !result.jobData && !result.videoData"
                               [result]="result"
                               [additionalInfo]="additionalInfo"
    ></mb-cms-search-result-item>
    <mb-cms-search-result-item-faq *ngIf="result.faqSnippet?.length"
                                   [result]="result"
    ></mb-cms-search-result-item-faq>
    <mb-cms-search-result-item-video *ngIf="result.videoData"
                                     [result]="result"
    ></mb-cms-search-result-item-video>
    <mb-cms-search-result-item-job *ngIf="result.jobData"
                                   [result]="result"
    ></mb-cms-search-result-item-job>
  </div>
</ng-container>
